var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"d-flex"},[(_vm.NavbarVertical && _vm.permisoVisualizador != 11)?_c('div',{staticClass:"mx-2",class:_vm.aboutClass},[_c('div',{class:{
          'mx-2 mt-1 text-center': !_vm.ocultar,
          ' text-center ms-3': _vm.ocultar,
        }},[_c('img',{attrs:{"src":require("@/assets/responsive.svg"),"alt":""},on:{"click":_vm.ocultarNavbar}})]),_c('nav',{staticClass:"px-0"},[_c('ul',{staticClass:"nav flex-column"},[_c('li',{staticClass:"nav-item w-100 text-center"},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":"/dashboard"}},[_c('div',{staticClass:"d-flex mt-1 pt-1"},[_c('svg',{class:{
                    'bi bi-house mb-1 pt-2  mx-auto  color ': !_vm.ocultar,
                    'bi bi-house mb-1 pt-2 ms-3 color ': _vm.ocultar,
                  },attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"}})]),(_vm.ocultar)?_c('p',{staticClass:"pt-2 my-auto tamaño w-100 ms-2"},[_vm._v(" INICIO ")]):_vm._e()])])],1)]),_c('ul',{staticClass:"nav flex-column text-left"},_vm._l((_vm.Items),function(item,index){return _c('li',{key:index.id,staticClass:"nav-item decorar"},[_c('div',{staticClass:"d-flex mt-2 bg-solimano w-100"},[_c('i',{class:[
                  {
                    ' mt-1 text-white fs-5 mb-1 mx-auto': !_vm.ocultar,
                    ' mt-1 text-white  fs-5 mb-1 ms-3': _vm.ocultar,
                  },
                  _vm.IconoModulo[index],
                ]}),(_vm.ocultar)?_c('p',{staticClass:"my-auto tamaño w-100 ms-3 text-white"},[_vm._v(" "+_vm._s(item)+" ")]):_vm._e()]),_vm._l((_vm.ModuloRapido),function(categoria,index){return _c('ul',{key:index.id,staticClass:"enlaces"},[_c('p',{staticClass:"text-decoration-none tamaño py-0 my-2",class:{
                  'categoria-seleccionada': _vm.categoriaSeleccionada === index,
                },on:{"click":function($event){return _vm.seleccionarCategoria(index)}}},[(
                    categoria.modNombre === item &&
                    categoria.catplataform == _vm.Plataforma
                  )?_c('router-link',{staticClass:"text-decoration-none tamaño",attrs:{"to":categoria.idCategoria == 20
                        ? {
                          name: categoria.idCategoria,
                          params: { contrato: _vm.idSolxPostulante },
                        }
                        : categoria.idCategoria == 27
                          ? {
                            name: categoria.idCategoria,
                            params: { use: _vm.idSolxPostulante },
                          }
                          : categoria.idCategoria == 26 ||
                            categoria.idCategoria == 18
                            ? {
                              name: categoria.idCategoria,
                              params: { idSol: _vm.idSolxPostulante },
                            }
                            : categoria.idCategoria == 32 ||
                              categoria.idCategoria == 33 ||
                              categoria.idCategoria == 34 ||
                              categoria.idCategoria == 35 ||
                              categoria.idCategoria == 36 ||
                              categoria.idCategoria == 37 ||
                              categoria.idCategoria == 39 ||
                              categoria.idCategoria == 29 ||
                              categoria.idCategoria == 50
                              ? { path: '/SeguimientoSolicitud' }
                              : categoria.idCategoria == 17 ||
                                categoria.idCategoria == 19 ||
                                categoria.idCategoria == 23 ||
                                categoria.idCategoria == 24 ||
                                categoria.idCategoria == 89
                                ? { path: '/gestionSolicitudes' }
                                : categoria.idCategoria == 43 ||
                                  categoria.idCategoria == 44 ||
                                  categoria.idCategoria == 63 ||
                                  categoria.idCategoria == 88
                                  ? { path: '/SeguimientoRenovacion' }
                                  : categoria.idCategoria == 41 ||
                                    categoria.idCategoria == 62
                                    ? { path: '/RegistroRenovaciones' }
                                    : categoria.idCategoria == 55 ||
                                      categoria.idCategoria == 52 ||
                                      categoria.idCategoria == 105

                                      ? { path: '/GestionCese' }
                                      : categoria.idCategoria == 51 ||
                                        categoria.idCategoria == 54 ||
                                        categoria.idCategoria == 53 ||
                                          categoria.idCategoria == 104
                                        ? { path: '/RegistroCeseInd' }
                                        : categoria.idCategoria == 61 ||
                                          categoria.idCategoria == 66 ||
                                          categoria.idCategoria == 65 ||
                                          categoria.idCategoria == 76 
                                        ? { path: '/DescuentoTecnologia' }
                                        : categoria.idCategoria == 77
                                        ? { path: '/CorreosTecnologia' }
                                            //  : categoria.idCategoria == 79 ||
                                            //   categoria.idCategoria == 67
                                            //  ? {path: '/PuntosDeVenta'}
                                            //  : categoria.idCategoria == 80 ||
                                            //   categoria.idCategoria == 68
                                            //  ? {path: '/Horarios'}
                                            //  : categoria.idCategoria == 69 ||
                                            //   categoria.idCategoria == 81
                                            //  ? {path: '/Ruta'}
                                            //  : categoria.idCategoria == 70 ||
                                            //   categoria.idCategoria == 82
                                            //  ? {path: '/ControlAsistencia'}



                                            //Horarios , Ruta , ControlAsistencia


                                         : { name: categoria.idCategoria }}},[_c('div',{staticClass:"d-flex",on:{"click":_vm.getAttributes}},[_c('i',{class:[
                        { 'mx-auto': !_vm.ocultar, 'ms-2': _vm.ocultar },
                        categoria.desIcono,
                        'fs-5',
                      ]}),(_vm.ocultar)?_c('p',{staticClass:"my-auto tamaño w-100 ms-3"},[_vm._v(" "+_vm._s(categoria.catNombre)+" ")]):_vm._e()])]):_vm._e()],1)])})],2)}),0)])]):_vm._e(),_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }